<script setup lang="ts">
import { ref } from "vue"
import { useForm } from "vuestic-ui"
import { useValidators } from "@shared/helpers/utils"
import { useI18n } from "vue-i18n"
import { useCommon } from "./composables/useCommon"

const emit = defineEmits(["close"])

const { t } = useI18n()
const validators = useValidators()
const userName = ref("")
const { impersonate } = useCommon()

const form = useForm("impersonate-form")

const onSave = async () => {
  if (form.validate()) {
    if (await impersonate(userName.value)) emit("close")
  }
}
</script>

<template>
  <VaForm ref="impersonate-form" class="flex-col justify-start items-start gap-4 inline-flex w-full">
    <div class="self-stretch flex-col justify-start items-start gap-4 flex">
      <div class="flex gap-4 flex-col sm:flex-row w-full">
        <VaInput
          v-model="userName"
          :label="t('impersonate.userName')"
          class="w-full"
          name="username"
          :rules="[validators.required]"
        />
      </div>
      <div class="flex gap-2 flex-col-reverse items-stretch justify-end w-full sm:flex-row sm:items-center">
        <VaButton preset="secondary" color="secondary" @click="$emit('close')">{{ t("general.cancel") }}</VaButton>
        <VaButton @click="onSave">{{ t("impersonate.start") }}</VaButton>
      </div>
    </div>
  </VaForm>
</template>
